import type { LocalizedField } from "~~/types/metadata";

export const ARMENIA_REGIONS: LocalizedField[] = [
  {
    en: "Abovyan",
    hy: "Աբովյան",
    ru: "Абовян",
  },
  {
    en: "Agarak",
    hy: "Ագարակ",
    ru: "Агарак",
  },
  {
    en: "Agarakadzor",
    hy: "Ագարակաձոր",
    ru: "Агаракадзор",
  },
  {
    en: "Agarakavan",
    hy: "Ագարակավան",
    ru: "Агаракаван",
  },
  {
    en: "Aghavnadzor",
    hy: "Աղավնաձոր",
    ru: "Агавнадзор",
  },
  {
    en: "Aghavnatun",
    hy: "Աղավնատուն",
    ru: "Агавнатун",
  },
  {
    en: "Akhtala",
    hy: "Ախթալա",
    ru: "Ахтала",
  },
  {
    en: "Akhuryan",
    hy: "Ախուրյան",
    ru: "Ахурян",
  },
  {
    en: "Aknalich",
    hy: "Ակնալիճ",
    ru: "Акналич",
  },
  {
    en: "Aknashen",
    hy: "Ակնաշեն",
    ru: "Акнашен",
  },
  {
    en: "Akner",
    hy: "Ակներ",
    ru: "Акнер",
  },
  {
    en: "Akunk",
    hy: "Ակունք",
    ru: "Акунк",
  },
  {
    en: "Alashkert",
    hy: "Ալաշկերտ",
    ru: "Алашкерт",
  },
  {
    en: "Alaverdi",
    hy: "Ալավերդի",
    ru: "Алаверди",
  },
  {
    en: "Amasia",
    hy: "Ամասիա",
    ru: "Амасия",
  },
  {
    en: "Angeghakot",
    hy: "Անգեղակոթ",
    ru: "Ангекахот",
  },
  {
    en: "Anushavan",
    hy: "Անուշավան",
    ru: "Анушаван",
  },
  {
    en: "Apaga",
    hy: "Ապագա",
    ru: "Апага",
  },
  {
    en: "Aparan",
    hy: "Ապարան",
    ru: "Апаран",
  },
  {
    en: "Arabkir",
    hy: "Արաբկիր",
    ru: "Арабкир",
  },
  {
    en: "Aragats",
    hy: "Արագած",
    ru: "Арагац",
  },
  {
    en: "Araks",
    hy: "Արաքս",
    ru: "Аракс",
  },
  {
    en: "Aralez",
    hy: "Արալեզ",
    ru: "Аралез",
  },
  {
    en: "Aramus",
    hy: "Արամուս",
    ru: "Арамус",
  },
  {
    en: "Ararat",
    hy: "Արարատ",
    ru: "Арарат",
  },
  {
    en: "Arazap",
    hy: "Արազափ",
    ru: "Аразап",
  },
  {
    en: "Arbat",
    hy: "Արբատ",
    ru: "Арбат",
  },
  {
    en: "Archis",
    hy: "Արչիս",
    ru: "Арчис",
  },
  {
    en: "Areni",
    hy: "Արենի",
    ru: "Арани",
  },
  {
    en: "Arevabuyr",
    hy: "Արևաբույր",
    ru: "Аревабуйр",
  },
  {
    en: "Arevashat",
    hy: "Արևաշատ",
    ru: "Аревашат",
  },
  {
    en: "Arevashogh",
    hy: "Արևաշող",
    ru: "Аревашох",
  },
  {
    en: "Arevik",
    hy: "Արևիկ",
    ru: "Аревик",
  },
  {
    en: "Arevshat",
    hy: "Արևշատ",
    ru: "Аревшат",
  },
  {
    en: "Argavand",
    hy: "Արգավանդ",
    ru: "Аргаванд",
  },
  {
    en: "Argel",
    hy: "Արգել",
    ru: "Аргель",
  },
  {
    en: "Armash",
    hy: "Արմաշ",
    ru: "Армаш",
  },
  {
    en: "Armavir",
    hy: "Արմավիր",
    ru: "Армавир",
  },
  {
    en: "Arrapi",
    hy: "Առափի",
    ru: "Аррапи",
  },
  {
    en: "Arshaluys",
    hy: "Արշալույս",
    ru: "Аршалуйс",
  },
  {
    en: "Artashat",
    hy: "Արտաշատ",
    ru: "Арташат",
  },
  {
    en: "Arteni",
    hy: "Արտենի",
    ru: "Артени",
  },
  {
    en: "Artimet",
    hy: "Արտիմետ",
    ru: "Артимет",
  },
  {
    en: "Artsvaberd",
    hy: "Արծվաբերդ",
    ru: "Арцваберд",
  },
  {
    en: "Arzakan",
    hy: "Արզական",
    ru: "Арзакан",
  },
  {
    en: "Arzni",
    hy: "Արզնի",
    ru: "Арзни",
  },
  {
    en: "Ashnak",
    hy: "Աշնակ",
    ru: "Ашнак",
  },
  {
    en: "Ashtarak",
    hy: "Աշտարակ",
    ru: "Аштарак",
  },
  {
    en: "Astghadzor",
    hy: "Աստղաձոր",
    ru: "Астгадзор",
  },
  {
    en: "Avshar",
    hy: "Ավշար",
    ru: "Авшар",
  },
  {
    en: "Aygavan",
    hy: "Այգավան",
    ru: "Айгаван",
  },
  {
    en: "Aygehovit",
    hy: "Այգեհովիտ",
    ru: "Айгеховит",
  },
  {
    en: "Aygek",
    hy: "Այգեկ",
    ru: "Айгек",
  },
  {
    en: "Aygepat",
    hy: "Այգեպատ",
    ru: "Айгепат",
  },
  {
    en: "Aygeshat",
    hy: "Այգեշատ",
    ru: "Айгешат",
  },
  {
    en: "Aygestan",
    hy: "Այգեստան",
    ru: "Айгестан",
  },
  {
    en: "Aygezard",
    hy: "Այգեզարդ",
    ru: "Айгезард",
  },
  {
    en: "Azatamut",
    hy: "Ազատամուտ",
    ru: "Азатамут",
  },
  {
    en: "Azatan",
    hy: "Ազատան",
    ru: "Азатан",
  },
  {
    en: "Baghramyan",
    hy: "Բաղրամյան",
    ru: "Баграмян",
  },
  {
    en: "Bagratashen",
    hy: "Բագրատաշեն",
    ru: "Баграташен",
  },
  {
    en: "Balahovit",
    hy: "Բալահովիտ",
    ru: "Балаховит",
  },
  {
    en: "Bambakashat",
    hy: "Բամբակաշատ",
    ru: "Бамбакашат",
  },
  {
    en: "Bardzrashen",
    hy: "Բարձրաշեն",
    ru: "Бардзрашен",
  },
  {
    en: "Basen",
    hy: "Բասեն",
    ru: "Басен",
  },
  {
    en: "Bazum",
    hy: "Բազում",
    ru: "Базум",
  },
  {
    en: "Berd",
    hy: "Բերդ",
    ru: "Берд",
  },
  {
    en: "Berdavan",
    hy: "Բերդավան",
    ru: "Бердаван",
  },
  {
    en: "Berkanush",
    hy: "Բերքանուշ",
    ru: "Берк'ануш",
  },
  {
    en: "Bjni",
    hy: "Բջնի",
    ru: "Бжни",
  },
  {
    en: "Brrnakot",
    hy: "Բռնակոթ",
    ru: "Бррнакот",
  },
  {
    en: "Burastan",
    hy: "Բուրաստան",
    ru: "Бурастан",
  },
  {
    en: "Buzhakan",
    hy: "Բուժական",
    ru: "Бужакан",
  },
  {
    en: "Byurakan",
    hy: "Բյուրական",
    ru: "Бюракан",
  },
  {
    en: "Byuravan",
    hy: "Բյուրավան",
    ru: "Бюраван",
  },
  {
    en: "Byureghavan",
    hy: "Բյուրեղավան",
    ru: "Бюрегаван",
  },
  {
    en: "Chambarak",
    hy: "Ճամբարակ",
    ru: "Чамбарак",
  },
  {
    en: "Chochkan",
    hy: "Չոչկան",
    ru: "Чочкан",
  },
  {
    en: "Dalar",
    hy: "Դալար",
    ru: "Далар",
  },
  {
    en: "Dalarik",
    hy: "Դալարիկ",
    ru: "Даларик",
  },
  {
    en: "Darakert",
    hy: "Դարակերտ",
    ru: "Даракерт",
  },
  {
    en: "Darpas",
    hy: "Դարպաս",
    ru: "Дарпас",
  },
  {
    en: "Dashtavan",
    hy: "Դաշտավան",
    ru: "Даштаван",
  },
  {
    en: "Ddmashen",
    hy: "Դդմաշեն",
    ru: "Ддмашен",
  },
  {
    en: "Dilijan",
    hy: "Դիլիջան",
    ru: "Дилижан",
  },
  {
    en: "Dimitrov",
    hy: "Դիմիտրով",
    ru: "Димитров",
  },
  {
    en: "Doghs",
    hy: "Դողս",
    ru: "Дохс",
  },
  {
    en: "Drakhtik",
    hy: "Դրախտիկ",
    ru: "Драхтик",
  },
  {
    en: "Dsegh",
    hy: "Ձաղ",
    ru: "Дсех",
  },
  {
    en: "Dvin",
    hy: "Դվին",
    ru: "Двин",
  },
  {
    en: "Dzithankov",
    hy: "Ձիթհանքով",
    ru: "Дзитханков",
  },
  {
    en: "Dzoraghbyur",
    hy: "Ձորաղբյուր",
    ru: "Дзорагбюр",
  },
  {
    en: "Dzoragyugh",
    hy: "Ձորագյուղ",
    ru: "Дзорагюх",
  },
  {
    en: "Dzorastan",
    hy: "Ձորաստան",
    ru: "Дзорастан",
  },
  {
    en: "Fantan",
    hy: "Ֆանտան",
    ru: "Фантан",
  },
  {
    en: "Fioletovo",
    hy: "Ֆիոլետովո",
    ru: "Фиолетово",
  },
  {
    en: "Gagarin",
    hy: "Գագարին",
    ru: "Гагарин",
  },
  {
    en: "Gandzak",
    hy: "Գանձակ",
    ru: "Гянджа",
  },
  {
    en: "Garrni",
    hy: "Գառնի",
    ru: "Гарни",
  },
  {
    en: "Gavarr",
    hy: "Գավառ",
    ru: "Гавар",
  },
  {
    en: "Gay",
    hy: "Գայ",
    ru: "Гай",
  },
  {
    en: "Geghakert",
    hy: "Գեղակերտ",
    ru: "Гегакерт",
  },
  {
    en: "Geghamasar",
    hy: "Գեղամասար",
    ru: "Гегамасар",
  },
  {
    en: "Geghamavan",
    hy: "Գեղամավան",
    ru: "Гегамаван",
  },
  {
    en: "Geghanist",
    hy: "Գեղանիստ",
    ru: "Геганист",
  },
  {
    en: "Getap",
    hy: "Գետափ",
    ru: "Гетап",
  },
  {
    en: "Getashen",
    hy: "Գետաշեն",
    ru: "Геташен",
  },
  {
    en: "Getazat",
    hy: "Գետազատ",
    ru: "Гетазат",
  },
  {
    en: "Ghukasavan",
    hy: "Ղուկասավան",
    ru: "Гукасаван",
  },
  {
    en: "Gladzor",
    hy: "Գլաձոր",
    ru: "Гладзор",
  },
  {
    en: "Gmbet",
    hy: "Գմբեթ",
    ru: "Гмбет",
  },
  {
    en: "Gogaran",
    hy: "Գոգարան",
    ru: "Гогаран",
  },
  {
    en: "Goght",
    hy: "Գողթ",
    ru: "Гохт",
  },
  {
    en: "Goravan",
    hy: "Գորավան",
    ru: "Гораван",
  },
  {
    en: "Goris",
    hy: "Գորիս",
    ru: "Горис",
  },
  {
    en: "Griboyedov",
    hy: "Գրիբոյեդով",
    ru: "Грибоедов",
  },
  {
    en: "Gugark",
    hy: "Գուգարք",
    ru: "Гугарк",
  },
  {
    en: "Gyulagarak",
    hy: "Գյուլագարակ",
    ru: "Гюлагарак",
  },
  {
    en: "Gyumri",
    hy: "Գյումրի",
    ru: "Гюмри",
  },
  {
    en: "Haghartsin",
    hy: "Հաղարծին",
    ru: "Агарцин",
  },
  {
    en: "Hatsavan",
    hy: "Հացավան",
    ru: "Ацаван",
  },
  {
    en: "Hayanist",
    hy: "Հայանիստ",
    ru: "Аянист",
  },
  {
    en: "Haykashen",
    hy: "Հայկաշեն",
    ru: "Айкашен",
  },
  {
    en: "Haykavan",
    hy: "Հայկավան",
    ru: "Айкаван",
  },
  {
    en: "Hnaberd",
    hy: "Հնաբերդ",
    ru: "Хнаберт",
  },
  {
    en: "Horrom",
    hy: "Հոռոմ",
    ru: "Хором",
  },
  {
    en: "Hovtamej",
    hy: "Հովտամեջ",
    ru: "Ховтамедж",
  },
  {
    en: "Hovtashat",
    hy: "Հովտաշատ",
    ru: "Ховташат",
  },
  {
    en: "Hovtashen",
    hy: "Հովտաշեն",
    ru: "Овташен",
  },
  {
    en: "Hrazdan",
    hy: "Հրազդան",
    ru: "Раздан",
  },
  {
    en: "Ijevan",
    hy: "Իջևան",
    ru: "Иджеван",
  },
  {
    en: "Janfida",
    hy: "Ջանֆիդա",
    ru: "Джанфида",
  },
  {
    en: "Jermuk",
    hy: "Ջերմուկ",
    ru: "Джермук",
  },
  {
    en: "Jrahovit",
    hy: "Ջրահովիտ",
    ru: "Джраховит",
  },
  {
    en: "Jrashen",
    hy: "Ջրաշեն",
    ru: "Джрашен",
  },
  {
    en: "Kamo",
    hy: "Կամո",
    ru: "Камо",
  },
  {
    en: "Kanakerravan",
    hy: "Քանաքեռավան",
    ru: "Канакераван",
  },
  {
    en: "Kapan",
    hy: "Կապան",
    ru: "Капан",
  },
  {
    en: "Kaputan",
    hy: "Կապուտան",
    ru: "Капутан",
  },
  {
    en: "Karanlukh",
    hy: "Կարանլուխ",
    ru: "Каранлух",
  },
  {
    en: "Karbi",
    hy: "Կարբի",
    ru: "Карби",
  },
  {
    en: "Karchaghbyur",
    hy: "Կարճաղբյուր",
    ru: "Карчахбюр",
  },
  {
    en: "Kasakh",
    hy: "Քասախ",
    ru: "Касах",
  },
  {
    en: "Khashtarrak",
    hy: "Խաշթառակ",
    ru: "Хашт'аррак",
  },
  {
    en: "Khndzoresk",
    hy: "Խնձորեսկ",
    ru: "Хндзореск",
  },
  {
    en: "Khoronk",
    hy: "Խորոնք",
    ru: "Хоронк",
  },
  {
    en: "Kosh",
    hy: "Կոշ",
    ru: "Кош",
  },
  {
    en: "Kotayk",
    hy: "Կոտայք",
    ru: "Котайк",
  },
  {
    en: "Lanjaghbyur",
    hy: "Լանջաղբյուր",
    ru: "Ланджахбюр",
  },
  {
    en: "Lchap",
    hy: "Լճափ",
    ru: "Лчап",
  },
  {
    en: "Lchashen",
    hy: "Լճաշեն",
    ru: "Лчашен",
  },
  {
    en: "Lenughi",
    hy: "Լենուղի",
    ru: "Ленуги",
  },
  {
    en: "Lerrnakert",
    hy: "Լեռնակերտ",
    ru: "Лернакерт",
  },
  {
    en: "Lerrnanist",
    hy: "Լեռնանիստ",
    ru: "Лернанист",
  },
  {
    en: "Lerrnantsk",
    hy: "Լեռնանցք",
    ru: "Лернантск",
  },
  {
    en: "Lerrnapat",
    hy: "Լեռնապատ",
    ru: "Лернапат",
  },
  {
    en: "Lerrnavan",
    hy: "Լեռնավան",
    ru: "Лернаван",
  },
  {
    en: "Lichk",
    hy: "Լիճք",
    ru: "Личк",
  },
  {
    en: "Lorut",
    hy: "Լորուտ",
    ru: "Лорут",
  },
  {
    en: "Lukashin",
    hy: "Լուկաշին",
    ru: "Лукашин",
  },
  {
    en: "Lusarrat",
    hy: "Լուսառատ",
    ru: "Лусаррат",
  },
  {
    en: "Madina",
    hy: "Մադինա",
    ru: "Мадина",
  },
  {
    en: "Malishka",
    hy: "Մալիշկա",
    ru: "Малишка",
  },
  {
    en: "Maralik",
    hy: "Մարալիկ",
    ru: "Маралик",
  },
  {
    en: "Margahovit",
    hy: "Մարգահովիտ",
    ru: "Маргаовит",
  },
  {
    en: "Margara",
    hy: "Մարգարա",
    ru: "Маргара",
  },
  {
    en: "Marmarashen",
    hy: "Մարմարաշեն",
    ru: "Мармарашен",
  },
  {
    en: "Marmashen",
    hy: "Մարմաշեն",
    ru: "Мармашен",
  },
  {
    en: "Martuni",
    hy: "Մարտունի",
    ru: "Мартуни",
  },
  {
    en: "Masis",
    hy: "Մասիս",
    ru: "Масис",
  },
  {
    en: "Mayakovski",
    hy: "Մայակովսկի",
    ru: "Маяковский",
  },
  {
    en: "Mayisyan",
    hy: "Մայիսյան",
    ru: "Майисян",
  },
  {
    en: "Meghradzor",
    hy: "Մեղրաձոր",
    ru: "Меградзор",
  },
  {
    en: "Meghrashen",
    hy: "Մեղրաշեն",
    ru: "Меграшен",
  },
  {
    en: "Meghri",
    hy: "Մեղրի",
    ru: "Мегри",
  },
  {
    en: "Merdzavan",
    hy: "Մերձավան",
    ru: "Мердзаван",
  },
  {
    en: "Metsamor",
    hy: "Մեծամոր",
    ru: "Мецамор",
  },
  {
    en: "Metsavan",
    hy: "Մեծավան",
    ru: "Мецаван",
  },
  {
    en: "Mets Mantash",
    hy: "Մեծ Մանտաշ",
    ru: "Мец Манташ",
  },
  {
    en: "Mets Masrik",
    hy: "Մեծ Մասրիկ",
    ru: "Мец Масрик",
  },
  {
    en: "Mets Parni",
    hy: "Մեծ Պառնի",
    ru: "Мец Парни",
  },
  {
    en: "Mosesgegh",
    hy: "Մովսեսգեղ",
    ru: "Мосесгег",
  },
  {
    en: "Mrganush",
    hy: "Մրգանուշ",
    ru: "Мргануш",
  },
  {
    en: "Mrgashat",
    hy: "Մրգաշատ",
    ru: "Мргашат",
  },
  {
    en: "Mrgashen",
    hy: "Մրգաշեն",
    ru: "Мргашен",
  },
  {
    en: "Mrgavan",
    hy: "Մրգավան",
    ru: "Мргаван",
  },
  {
    en: "Mrgavet",
    hy: "Մրգավետ",
    ru: "Мргавет",
  },
  {
    en: "Musalerr",
    hy: "Մուսալեռ",
    ru: "Мусалер",
  },
  {
    en: "Myasnikyan",
    hy: "Մյասնիկյան",
    ru: "Мясникян",
  },
  {
    en: "Nalbandyan",
    hy: "Նալբանդյան",
    ru: "Налбандян",
  },
  {
    en: "Navur",
    hy: "Նավուր",
    ru: "Навур",
  },
  {
    en: "Nerkin Getashen",
    hy: "Ներքին Գետաշեն",
    ru: "Неркин Геташен",
  },
  {
    en: "Nizami",
    hy: "Նիզամի",
    ru: "Низами",
  },
  {
    en: "Norabats",
    hy: "Նորաբաց",
    ru: "Норабац",
  },
  {
    en: "Norakert",
    hy: "Նորակերտ",
    ru: "Норакерт",
  },
  {
    en: "Noramarg",
    hy: "Նորամարգ",
    ru: "Норамарк",
  },
  {
    en: "Nor Armavir",
    hy: "Նոր Արմավիր",
    ru: "Нор Армавир",
  },
  {
    en: "Norashen",
    hy: "Նորաշեն",
    ru: "Норашен",
  },
  {
    en: "Noratus",
    hy: "Նորատուս",
    ru: "Норатус",
  },
  {
    en: "Nor Geghi",
    hy: "Նոր Գեղի",
    ru: "Нор Гехи",
  },
  {
    en: "Nor Gyugh",
    hy: "Նոր Գյուղ",
    ru: "Нор Гюх",
  },
  {
    en: "Nor Yerznka",
    hy: "Նոր Երզնկա",
    ru: "Нор Ерзнка",
  },
  {
    en: "Noyakert",
    hy: "Նոյակերտ",
    ru: "Ноякерт",
  },
  {
    en: "Noyemberyan",
    hy: "Նոյեմբերյան",
    ru: "Ноемберян",
  },
  {
    en: "Nshavan",
    hy: "Նշավան",
    ru: "Ншаван",
  },
  {
    en: "Odzun",
    hy: "Օձուն",
    ru: "Одзуни",
  },
  {
    en: "Oshakan",
    hy: "Օշական",
    ru: "Ошака́н",
  },
  {
    en: "Parravakar",
    hy: "Փառավաքար",
    ru: "Парравакар",
  },
  {
    en: "Pemzashen",
    hy: "Պեմզաշեն",
    ru: "Пемзашен",
  },
  {
    en: "Pokr Mantash",
    hy: "Փոքր Մանթաշ",
    ru: "Покр Манташ",
  },
  {
    en: "Prroshyan",
    hy: "Փռոշյան",
    ru: "Прошян",
  },
  {
    en: "Pshatavan",
    hy: "Փշատավան",
    ru: "Пшатаван",
  },
  {
    en: "Ptghni",
    hy: "Պտղնի",
    ru: "Птхни",
  },
  {
    en: "Ptghunk",
    hy: "Պտղունք",
    ru: "Птгунк",
  },
  {
    en: "Rrind",
    hy: "Ռրինդ",
    ru: "Рринд",
  },
  {
    en: "Sarahart",
    hy: "Սարահարթ",
    ru: "Сараарт",
  },
  {
    en: "Saralanj",
    hy: "Սարալանջ",
    ru: "Сараландж",
  },
  {
    en: "Saramej",
    hy: "Սարամեջ",
    ru: "Сарамеж",
  },
  {
    en: "Saratak",
    hy: "Սարատակ",
    ru: "Саратак",
  },
  {
    en: "Sardarapat",
    hy: "Սարդարապատ",
    ru: "Сардарапат",
  },
  {
    en: "Sarigyugh",
    hy: "Սարիգյուղ",
    ru: "Саригюх",
  },
  {
    en: "Sarukhan",
    hy: "Սարուխան",
    ru: "Сарухан",
  },
  {
    en: "Sasunik",
    hy: "Սասունիկ",
    ru: "Сасуник",
  },
  {
    en: "Sayat-Nova",
    hy: "Սայաթ Նովա",
    ru: "Саят-Нова",
  },
  {
    en: "Sevan",
    hy: "Սևան",
    ru: "Севан",
  },
  {
    en: "Shaghat",
    hy: "Շաղաթ",
    ru: "Шагат",
  },
  {
    en: "Shahumyan",
    hy: "Շահումյան",
    ru: "Шаумян",
  },
  {
    en: "Shatin",
    hy: "Շատին",
    ru: "Шатин",
  },
  {
    en: "Shenavan",
    hy: "Շենավան",
    ru: "Шенаван",
  },
  {
    en: "Shinuhayr",
    hy: "Շինուհայր",
    ru: "Шинуайр",
  },
  {
    en: "Shirak",
    hy: "Շիրակ",
    ru: "Ширак",
  },
  {
    en: "Shirakamut",
    hy: "Շիրակամուտ",
    ru: "Ширакамут",
  },
  {
    en: "Shnogh",
    hy: "Շնող",
    ru: "Шнох",
  },
  {
    en: "Sis",
    hy: "Սիս",
    ru: "Сис",
  },
  {
    en: "Sisavan",
    hy: "Սիսավան",
    ru: "Сисаван",
  },
  {
    en: "Solak",
    hy: "Սոլակ",
    ru: "Солак",
  },
  {
    en: "Spandaryan",
    hy: "Սպանդարյան",
    ru: "Спандарян",
  },
  {
    en: "Spitak",
    hy: "Սպիտակ",
    ru: "Спитак",
  },
  {
    en: "Stepanavan",
    hy: "Ստեփանավան",
    ru: "Степанаван",
  },
  {
    en: "Surenavan",
    hy: "Սուրենավան",
    ru: "Суренаван",
  },
  {
    en: "Talin",
    hy: "Թալին",
    ru: "Талин",
  },
  {
    en: "Tandzut",
    hy: "Տանձուտ",
    ru: "Тандзут",
  },
  {
    en: "Taronik",
    hy: "Տարոնիկ",
    ru: "Тароник",
  },
  {
    en: "Tashir",
    hy: "Տաշիր",
    ru: "Ташир",
  },
  {
    en: "Tegh",
    hy: "Տեղ",
    ru: "Тег",
  },
  {
    en: "Tsaghkaber",
    hy: "Ծաղկաբեր",
    ru: "Цахкабер",
  },
  {
    en: "Tsaghkadzor",
    hy: "Ծաղկաձոր",
    ru: "Цахкадзор",
  },
  {
    en: "Tsaghkahovit",
    hy: "Ծաղկահովիտ",
    ru: "Цахкаховит",
  },
  {
    en: "Tsaghkunk",
    hy: "Ծաղկունք",
    ru: "Цахкунк",
  },
  {
    en: "Tsiatsan",
    hy: "Ծիածան",
    ru: "Циацан",
  },
  {
    en: "Tsovagyugh",
    hy: "Ծովագյուղ",
    ru: "Цовагюх",
  },
  {
    en: "Tsovak",
    hy: "Ծովակ",
    ru: "Цовак",
  },
  {
    en: "Tsovasar",
    hy: "Ծովասար",
    ru: "Цовасар",
  },
  {
    en: "Tsovazard",
    hy: "Ծովազարդ",
    ru: "Цовазард",
  },
  {
    en: "Tsovinar",
    hy: "Ծովինար",
    ru: "Цовинар",
  },
  {
    en: "Urrut",
    hy: "Ուռուտ",
    ru: "Урут",
  },
  {
    en: "Ushi",
    hy: "Ուշի",
    ru: "Уши",
  },
  {
    en: "Vagharshapat",
    hy: "Վաղարշապատ",
    ru: "Вагаршапат",
  },
  {
    en: "Vaghashen",
    hy: "Վաղաշեն",
    ru: "Вагашен",
  },
  {
    en: "Vahagni",
    hy: "Վահագնի",
    ru: "Вахагни",
  },
  {
    en: "Vahan",
    hy: "Վահան",
    ru: "Вахан",
  },
  {
    en: "Vanadzor",
    hy: "Վանաձոր",
    ru: "Ванадзор",
  },
  {
    en: "Vardablur",
    hy: "Վարդաբլուր",
    ru: "Вардаблур",
  },
  {
    en: "Vardadzor",
    hy: "Վարդաձոր",
    ru: "Вардадзор",
  },
  {
    en: "Vardenik",
    hy: "Վարդենիկ",
    ru: "Варденик",
  },
  {
    en: "Vardenis",
    hy: "Վարդենիս",
    ru: "Варденис",
  },
  {
    en: "Varser",
    hy: "Վարսեր",
    ru: "Варсер",
  },
  {
    en: "Vayk",
    hy: "Վայք",
    ru: "Вайк",
  },
  {
    en: "Vedi",
    hy: "Վեդի",
    ru: "Веди",
  },
  {
    en: "Verin Artashat",
    hy: "Վերին Արտաշատ",
    ru: "Верин Арташат",
  },
  {
    en: "Verin Dvin",
    hy: "Վերին Դվին",
    ru: "Верин Двин",
  },
  {
    en: "Verin Getashen",
    hy: "Վերին Գետաշեն",
    ru: "Верин Геташен",
  },
  {
    en: "Verishen",
    hy: "Վերիշեն",
    ru: "Веришен",
  },
  {
    en: "Vernashen",
    hy: "Վերնաշեն",
    ru: "Вернашен",
  },
  {
    en: "Voskehask",
    hy: "Ոսկեհասկ",
    ru: "Воскеаск",
  },
  {
    en: "Voskehat",
    hy: "Ոսկեհատ",
    ru: "Воскеат",
  },
  {
    en: "Vosketap",
    hy: "Ոսկետափ",
    ru: "Воскетап",
  },
  {
    en: "Voskevan",
    hy: "Ոսկեվան",
    ru: "Воскеван",
  },
  {
    en: "Voskevaz",
    hy: "Ոսկեվազ",
    ru: "Воскеваз",
  },
  {
    en: "Vostan",
    hy: "Վոստան",
    ru: "Востан",
  },
  {
    en: "Yeghegis",
    hy: "Եղեգիս",
    ru: "Ехегис",
  },
  {
    en: "Yeghegnadzor",
    hy: "Եղեգնաձոր",
    ru: "Ехегнадзор",
  },
  {
    en: "Yeghegnavan",
    hy: "Եղեգնավան",
    ru: "Ехегнаван",
  },
  {
    en: "Yeghegnut",
    hy: "Եղեգնուտ",
    ru: "Ехегнут",
  },
  {
    en: "Yeghvard",
    hy: "Եղվարդ",
    ru: "Ехвард",
  },
  {
    en: "Yeranos",
    hy: "Երանոս",
    ru: "Еранос",
  },
  {
    en: "Yeraskhahun",
    hy: "Երասխահուն",
    ru: "Ерасхахун",
  },
  {
    en: "Yerazgavors",
    hy: "Երազգավորս",
    ru: "Еразгаворс",
  },
  {
    en: "Yerevan",
    hy: "Երևան",
    ru: "Ереван",
  },
  {
    en: "Zangakatun",
    hy: "Զանգակատուն",
    ru: "Зангакадун",
  },
  {
    en: "Zarr",
    hy: "Զարր",
    ru: "Зарр",
  },
  {
    en: "Zarritap",
    hy: "Զառիթափ",
    ru: "Зарритап",
  },
  {
    en: "Zorak",
    hy: "Զորակ",
    ru: "Зорак",
  },
  {
    en: "Zoravan",
    hy: "Զորավան",
    ru: "Зораван",
  },
  {
    en: "Zovaber",
    hy: "Զովաբեր",
    ru: "Зовабер",
  },
  {
    en: "Zovuni",
    hy: "Զովունի",
    ru: "Зовуни",
  },
];
